export function append(base: string, str: string, separator?: string): string {
    if (!str) {
        return base;
    }
    if (separator && base) {
        return base + separator + str;
    }
    return base + str;
}